module.exports = __webpack_public_path__ + "99cea8716ad4f8059f7361a30e44aeb0.png";